export default __webpack_public_path__ + "static/therock-johnson-1a73a0ef2933a413103a7967a5190db8.jpg";